<template>
  <div>
    <v-container>
      <v-row v-if="verListaPreguntas">
        <alertaMensaje :snackbar="mostrarSnackbar" :mensajeAlertaData="mensajeAlerta" @update-snackbar="hideSnackbar">
        </alertaMensaje>

        <confirmButton :dialogConfirm="mostrarDialogConfirm" :mensajeDialogData="mensajeDialog"
          @update-dialog="confirmDelete" @open-dialog="mostrarDialogConfirm = $event"></confirmButton>

        <v-col cols="12">
          <v-btn class="btn_style3" dark @click="cambiarVista()">VOLVER</v-btn>
        </v-col>
        <v-col cols="2">
          <v-text-field readonly primary v-model="parametros.item.desc_nivel" label="NIVEL" type="text"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field readonly primary v-model="parametros.item.desc_grado" label="GRADO" type="text"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field readonly primary v-model="parametros.item.desc_area" label="AREA" type="text"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field readonly primary v-model="parametros.item.desc_curso" label="CURSO" type="text"></v-text-field>
        </v-col>

        <v-col cols="6">
          <v-alert border="left" color="primary" dense shaped type="success">{{
            parametros.event == "view_balotario"
            ? parametros.item.unidad + " : " + parametros.item.tema
            : parametros.item.nombre_tema + " : " + parametros.item.nombre_clase
          }}</v-alert>
        </v-col>
        <v-col cols="6" class="text-end">
          <v-btn @click="ViewFormulario()" rounded color="primary">
            <v-icon left> mdi-plus </v-icon>
            Crear pregunta
          </v-btn>
          <v-btn class="ml-2" @click="ViewPreviewSimulador()" rounded color="success">
            <v-icon left> mdi-content-paste </v-icon>
            Ver simulador
          </v-btn>
          <v-btn class="ml-2" rounded color="error" @click="eliminarPreguntaDeactivate()">
            <v-icon left> mdi-delete </v-icon>

            Eliminar
          </v-btn>
        </v-col>
        <v-col cols="12">
          <!-- v-sortable -->
          <v-data-table :items-per-page="sizePerPage" :search="searchPreguntas" :headers="headerPregunta"
            :items="arrayPreguntasClase" v-sortable :page.sync="page" hide-default-footer
            @sorted="cambiarOrden($event, parametros.item.id)" show-select sort-by="nombre_tema" item-key="idpregunta"
            class="elevation-1" @toggle-select-all="selecionaTodosPregunta" @page-count="pageCount = $event"
            @pagination="getPagination">
            <template v-slot:[`header.data-table-select`]="{ props, on }">
              <v-btn class="pl-0" plain small color="dark">
                <v-simple-checkbox :value="props.value" v-on="on" />

                <!-- <v-icon>mdi-arrow-down-thick</v-icon> -->

                <!-- <span>Selecciona</span> -->
              </v-btn>
            </template>

            <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
              <v-simple-checkbox color="red" :value="isSelected" @input="
                select($event),
                seleccionIndividualPregunta(
                  $event,

                  item,

                  isSelected,

                  select
                )
                ">
              </v-simple-checkbox>
            </template>
            <!-- d-none -->
            <template v-slot:[`header.idpregunta`]="{ header }">
              <div class="">
                {{ header.idpregunta }}
              </div>
            </template>
            <!-- d-none -->
            <template v-slot:[`item.idpregunta`]="{ item }">
              <div class="" style="color: #00000000">
                {{ item.idpregunta }}
              </div>
            </template>

            <template v-slot:[`item.titulo`]="{ item }">
              <p class="pt-2" v-html="item.titulo"></p>
            </template>

            <template v-slot:[`item.dificultad`]="{ item }">
              <v-chip v-if="item.dificultad == 0" :color="`blue`" class="ml-0 mr-2 black--text" label small>
                BAJA
              </v-chip>

              <v-chip v-if="item.dificultad == 1" :color="`success`" text-color="white" class="ml-0 mr-2 black--text"
                label small>
                MEDIA
              </v-chip>

              <v-chip v-if="item.dificultad == 2" :color="`red`" class="ml-0 mr-2 black--text" label small>
                ALTA
              </v-chip>
            </template>

            <template v-slot:[`item.tipo`]="{ item }">
              <v-chip v-if="item.tipo == 'res_uni'" :color="`blue lighten-4`" class="ml-0 mr-2 black--text" label small>
                Respuesta Única
              </v-chip>

              <v-chip v-if="item.tipo == 'res_mul'" :color="`green lighten-4`" class="ml-0 mr-2 black--text" label small>
                Respuesta Múltiple
              </v-chip>

              <v-chip v-if="item.tipo == 'ver_fal'" :color="`red lighten-4`" class="ml-0 mr-2 black--text" label small>
                Verdadero - Falso
              </v-chip>
            </template>

            <template v-slot:[`item.orden`]="{ item }">
              <strong>{{ item.orden }}</strong>
            </template>

            <template v-slot:[`item.ver`]="{ item }">
              <v-tooltip bottom color="#1b1b1b">
                <template v-slot:activator="{ on }">
                  <v-btn :loading="loading[item.idpregunta]" :disabled="loading[item.idpregunta]" v-on="on"
                    class="btn_editar px-0 mx-0" fab x-small @click="changeView('contenedor3', idclase, item)">
                    <v-icon>fa-pencil-alt</v-icon>
                  </v-btn>
                </template>
                <span>EDITAR</span>
              </v-tooltip>
            </template>
          </v-data-table>

          <v-row>
            <v-col cols="2">
              <v-select class="ml-4 pt-6" v-model="sizePerPage" :items="itemsPerPage" label="items por pagina"
                @change="sizePerPage = parseInt($event, 10)">
              </v-select>
            </v-col>
            <v-col cols="10">
              <div class="d-flex justify-end pt-2">
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @closeL="CloseModalL()">
    </component>
  </div>
</template>

<script>
// import NProgress from "nprogress";
import "nprogress/nprogress.css";
import axios from "@/helpers/axios";
// import { mapState, mapMutations } from "vuex";
import Sortable from "sortablejs";
export default {
  name: "listaPreguntas",
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  components: {
    alertaMensaje: () => import("../../SimuladorExamenes/components/Co-alertaMensaje.vue"),
    confirmButton: () => import("../../SimuladorExamenes/components/Co-ComfirMensaje.vue"),
    formularioPregunta: () => import("./formularioPregunta.vue"),
    previewSimulador: () => import("./previewSimulador.vue"),
  },
  data: () => ({
    desc_nivel: "",
    desc_grado: "",
    desc_area: "",
    desc_curso: "",
    desc_unidad: "",
    searchPreguntas: "",
    sizePerPage: 10,
    itemsPerPage: [5, 10, 15],
    page: 1,
    pageCount: 0,
    headerPregunta: [
      { text: "ID", value: "idpregunta", sortable: false },
      { text: "TITULO", value: "titulo", sortable: false },
      { text: "DIFICULTAD", value: "dificultad", sortable: false },
      { text: "ORDEN", value: "orden", sortable: false },
      { text: "TIPO", value: "tipo", sortable: false },
      { text: "EDITAR", value: "ver", sortable: false },
    ],
    arrayPreguntasClase: [],
    arrayPreguntaDeleted: [],
    loading: [],
    verListaPreguntas: true,
    compName: null,
    estadoComponente: null,
    parametroComp: [],

    // Variables de alerta
    mostrarSnackbar: false,
    mensajeAlerta: "",

    // Variable de AlertConfim
    mostrarDialogConfirm: false,
    validaDialogConfirm: false,
    mensajeDialog: "",
  }),
  methods: {
    cambiarVista() {
      this.$emit("closeB");
      this.arrayPreguntasClase = [];
    },
    hideSnackbar(e) {
      this.mostrarSnackbar = e;
    },
    eliminarPreguntaDeactivate() {
      const me = this;
      if (me.arrayPreguntaDeleted.length > 0) {
        me.mensajeDialog = "¿ Estás seguro de eliminar datos ?";
        me.mostrarDialogConfirm = true;
      } else {
        alert("No selecciono ninguna Fila");
      }
    },
    seleccionIndividualPregunta(event, item) {
      // , isSelected, select
      const me = this;
      if (event === true) {
        me.arrayPreguntaDeleted.push(item.idpregunta);
      } else {
        let index = me.arrayPreguntaDeleted.indexOf(item.idpregunta);

        if (index !== -1) {
          me.arrayPreguntaDeleted.splice(index, 1);
        }
      }

      console.log(me.arrayPreguntaDeleted);
    },
    selecionaTodosPregunta(event) {
      const me = this;
      if (event.value == true) {
        me.arrayPreguntaDeleted = [];
        let arrayitems = event.items;
        arrayitems.forEach((element) => {
          me.arrayPreguntaDeleted.push(element.idpregunta);
        });
      } else {
        me.arrayPreguntaDeleted = [];
      }
    },
    async confirmDelete(e) {
      const me = this;

      me.validaDialogConfirm = e;

      if (e == true) {
        try {
          const response = await axios.put(
            "/simulador/simuladorExamen/simuladorPreguntas/simuladorP/changestatepregunta/",
            {
              arrayidpregunta: me.arrayPreguntaDeleted,
            }
          );

          me.mostrarDialogConfirm = false;
          console.log(response.data);
          me.listarPreguntas();
          me.mostrarSnackbar = true;
          me.mensajeAlerta = response.data.message;
          me.mostrarDialogConfirm = false;
          // me.listarPreguntasAgrupadas();
        } catch (error) {
          me.mostrarDialogConfirm = false;
          console.log(error);
        }
      }
    },
    getPagination(pagination) {
      const me = this;
      me.paginationData = pagination;
    },
    cambiarOrden(event, idtema) {
      const me = this;
      console.log(idtema);
      const ordenNew = event.newIndex + me.paginationData.pageStart + 1;
      const movedItem = me.arrayPreguntasClase.splice(
        event.oldIndex + me.paginationData.pageStart,
        1
      )[0];
      me.arrayPreguntasClase.splice(
        event.newIndex + me.paginationData.pageStart,
        0,
        movedItem
      );
      me.arrayPreguntasClase[
        event.newIndex + me.paginationData.pageStart
      ].orden = ordenNew;

      for (let i = 0; i < event.target.children.length; i++) {
        me.modificarOrdenPreguntas(
          idtema,
          event.target.children[i].children[1].innerText,
          me.paginationData.pageStart + i + 1
        );
        let numit = Number(me.paginationData.pageStart + i + 1 - 1);
        // console.log(numit);
        me.arrayPreguntasClase[numit].orden =
          me.paginationData.pageStart + i + 1;
      }
      me.mostrarSnackbar = true;
      me.mensajeAlerta = "Orden Cambiado";
    },
    async modificarOrdenPreguntas(idtema, idpregunta, newIndex) {
      // const me = this;
      try {
        await axios.put(
          "/simulador/simuladorExamen/simuladorPreguntas/simuladorP/actualizaIndice/" +
          idtema,
          {
            orden_new: newIndex,
            idpregunta: idpregunta,
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async listarPreguntas() {
      const me = this;
      try {
        const response = await axios.get(
          "/simulador/simuladorExamen/simuladorPreguntas/simuladorP/lista/" +
          me.parametros.item.id
        );

        me.arrayPreguntasClase = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    ViewFormulario() {
      const me = this;
      me.verListaPreguntas = false;
      me.parametroComp = {
        items: me.parametros,
        cantidad: me.arrayPreguntasClase,
      };
      me.compName = "formularioPregunta";
      me.estadoComponente = true;
    },
    ViewPreviewSimulador() {
      const me = this;
      me.verListaPreguntas = false;
      me.parametroComp = {
        items: me.parametros,
        cantidad: me.arrayPreguntasClase,
      };
      me.compName = "previewSimulador";
      me.estadoComponente = true;
    },
    CloseModalL() {
      const me = this;
      me.estadoComponente = false;
      me.verListaPreguntas = true;
      me.listarPreguntas();
    },
    init() {
      const me = this;
      me.listarPreguntas();
      console.log(me.parametros);
      // me.arrayPreguntasClase = me.parametros.ListaPreguntas;
    },
  },
  directives: {
    sortable: {
      bind(el, binding, vnode) {
        const options = {
          animation: 150,
          onUpdate: function (event) {
            vnode.child.$emit("sorted", event);
          },
        };
        Sortable.create(el.getElementsByTagName("tbody")[0], options);
      },
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    estadoComp() {
      if (this.estadoComp) {
        this.verListaPreguntas = true;
        this.init();
      } else {
        this.verListaPreguntas = false;
      }
    },
  },
};
</script>

<style scoped>
.v-data-table-header {
  background-color: rgb(174, 174, 174) !important;
}

thead tr:first-child th:first-child {
  background-color: #aeaeae;
}
</style>
